import gql from 'graphql-tag';

export const GET_FINANCE_PROGRAMS = gql`
  query FinancePrograms($accountId: ID!) {
    financePrograms(accountId: $accountId) {
      accountId
      financeProgramId
      nameInternal
      paymentOptionsConfiguration
      validDateEnd
      validDateStart
      modifiedDateTime
      insuranceCoverage {
        coverageRequirements
        certificateRequirements
        otherInstructions
      }
      prescreenCriteria {
        prescreenCriteriaId
        accountId
        active
        jsonCriteria
        name
        guidelines
      }
      financeProgramModificationSettings {
        markup
      }
      financeProgramToLenderProfiles {
        lenderProfileId
        isDisabled
      }
    }
  }
`;
